import { Keyword } from "../textual/keyword.js";
/**
 * @public
 */
export var Keywords;
(function (Keywords) {
    /**
     * @internal
     */
    Keywords.parseCenter = Keyword.parse("center");
    /**
     * @internal
     */
    Keywords.parseVertical = Keyword.parse("top", "bottom");
    /**
     * @internal
     */
    Keywords.parseHorizontal = Keyword.parse("left", "right");
})(Keywords || (Keywords = {}));
//# sourceMappingURL=keywords.js.map